import React from "react";
import "./Flash.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import image from "../../Media/KHI.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283899578378&text=Halo%20Tari,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Harapan%20Indah%20(Flash%20Sale)%20https://kotaharapanindahmarketing.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="siaphuni" className="flash">
      <div className="foto">
        <img className="fotohome" src={image} alt={image} />
      </div>
      <div className="container-fasilitas">
        <h1>Kota Harapan Indah</h1>
        <h2>Flash Sale Discount Up To 50%</h2>
        <hr color="white" />
        <div className="container-desk">
          <div className="desksurrounding">
            Berikut adalah pilihan beberapa cluster yang sudah siap huni di
            kawasan Kota harapan indah :
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Lavesh</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Kana</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Asera</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Albasia</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Adara</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Ifolia</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Samata</span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Damar</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Ebony</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Mega Office Park</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Ruko Komersial Asera
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
